// composer/emojiData.ts — curated emoji grid for the composer's emoji picker.
//
// Native unicode characters only — no dependency, no emoji-as-UI (this content is
// user-typed post text once inserted, not a UI symbol).

export interface EmojiCategory {
  label: string;
  emoji: string[];
}

export const EMOJI_CATEGORIES: EmojiCategory[] = [
  {
    label: 'Smileys',
    emoji: ['😀', '😁', '😂', '🤣', '😊', '😍', '😘', '😜', '🤔', '😎', '🥳', '😴'],
  },
  {
    label: 'Gestures',
    emoji: ['👍', '👎', '👏', '🙌', '🙏', '👋', '💪', '🤝', '✌️', '🤙', '👊', '🤞'],
  },
  {
    label: 'Hearts',
    emoji: ['❤️', '🧡', '💛', '💚', '💙', '💜', '🖤', '🤍', '💔', '💕', '💯', '✨'],
  },
  {
    label: 'People',
    emoji: ['🙋', '🤷', '🧑‍💻', '🕺', '💃', '🫡', '🤝', '👀', '🗣️', '🧠', '🤯', '🥸'],
  },
  {
    label: 'Animals',
    emoji: ['🐶', '🐱', '🦊', '🐻', '🐼', '🦁', '🐸', '🐧', '🦉', '🐢', '🐝', '🦄'],
  },
  {
    label: 'Food',
    emoji: ['🍕', '🍔', '🌮', '🍣', '🍩', '🍪', '☕', '🍺', '🍿', '🥑', '🍉', '🎂'],
  },
  {
    label: 'Activities',
    emoji: ['⚽', '🏀', '🎮', '🎸', '🎨', '📷', '🎬', '🚀', '🏆', '🎯', '🧩', '🎲'],
  },
  {
    label: 'Symbols',
    emoji: ['🔥', '⭐', '💡', '⚡', '✅', '❌', '❓', '❗', '🔒', '🌐', '📌', '🎉'],
  },
];
